export default __webpack_public_path__ + "3cc0bea286794852e6bdbae54386657d.png";